import { render, staticRenderFns } from "./Advance-Update.vue?vue&type=template&id=627f64b0&"
import script from "./Advance-Update.vue?vue&type=script&lang=js&"
export * from "./Advance-Update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports